import { CommunityChannelApi } from '@ps/api/community-channel';
import { withClientAPI } from '@ps/functions/utils/api';

/**
 * Leave a community channel — removes the current user as a member of
 * `stores/{creatorId}/communityChannels/{channelId}`. The live membership doc
 * subscription (`useMyChannelMembership`) then flips the viewer back to the
 * non-member gate. Mirrors PopshopRN's `useLeaveCommunityChannel`.
 */
export async function leaveChannel({
  creatorId,
  channelId,
  userId,
}: {
  creatorId: string;
  channelId: string;
  userId: string;
}): Promise<void> {
  const api = withClientAPI(CommunityChannelApi);
  await api.communityChannelApiControllerRemoveMemberFromCommunityChannel({
    sellerId: creatorId,
    channelId,
    memberId: userId,
  });
}
